define("checkout/components/payment/stripe-payment-element/index", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div
    class="o--formWrapper u--m__b"
    data-test-id="payment-card"
    id="payment-form"
    ...attributes
    {{did-insert this.setupStripeForm}}
  >
    {{#if this.isLabelVisible}}
      <label class="u--m__t__xs" for="e--stripe-payment-element">{{t "plans.checkout.plan.card_type"}}</label>
    {{/if}}
    <div class="dd-privacy-mask-user-input tCH--stripeForm" id="e--stripe-payment-element">
      {{! a Stripe Element will be inserted here. }}
    </div>
    {{! Used to display form errors }}
    <span class="o--form__helpText u--text--danger" data-test-id="error" id="e--card-errors">
      {{#if (and this.hasTouchedCard this.isCardEmpty (not this.isWalletSelected))}}
        {{t "plans.checkout.card.missing_info"}}
      {{/if}}
    </span>
  </div>
  */
  {
    "id": "PZByNfOK",
    "block": "[[[11,0],[24,0,\"o--formWrapper u--m__b\"],[24,\"data-test-id\",\"payment-card\"],[24,1,\"payment-form\"],[17,1],[4,[38,0],[[30,0,[\"setupStripeForm\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isLabelVisible\"]],[[[1,\"    \"],[10,\"label\"],[14,0,\"u--m__t__xs\"],[14,\"for\",\"e--stripe-payment-element\"],[12],[1,[28,[35,2],[\"plans.checkout.plan.card_type\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"dd-privacy-mask-user-input tCH--stripeForm\"],[14,1,\"e--stripe-payment-element\"],[12],[1,\"\\n\"],[1,\"  \"],[13],[1,\"\\n\"],[1,\"  \"],[10,1],[14,0,\"o--form__helpText u--text--danger\"],[14,\"data-test-id\",\"error\"],[14,1,\"e--card-errors\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"hasTouchedCard\"]],[30,0,[\"isCardEmpty\"]],[28,[37,4],[[30,0,[\"isWalletSelected\"]]],null]],null],[[[1,\"      \"],[1,[28,[35,2],[\"plans.checkout.card.missing_info\"],null]],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"&attrs\"],false,[\"did-insert\",\"if\",\"t\",\"and\",\"not\"]]",
    "moduleName": "checkout/components/payment/stripe-payment-element/index.hbs",
    "isStrictMode": false
  });
  let StripePaymentElementComponent = _exports.default = (_class = class StripePaymentElementComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "stripe", _descriptor, this);
      _defineProperty(this, "paymentElement", void 0);
      _defineProperty(this, "paymentElementElements", void 0);
      // Note: set to true when stripe card is first focused and edited
      _initializerDefineProperty(this, "hasTouchedCard", _descriptor2, this);
      _initializerDefineProperty(this, "hasFocusedCard", _descriptor3, this);
      _initializerDefineProperty(this, "isCardEmpty", _descriptor4, this);
      /**
       * Note: for some reason, on load this event will fire twice.
       * 1. event.empty: false
       * 2. event.empty: true
       */
      _defineProperty(this, "paymentElementChangeHandler", event => {
        this.isCardEmpty = event.empty;
        if (!this.paymentElementElements) {
          return;
        }

        // Set true forever once touched
        this.hasTouchedCard = this.hasTouchedCard || this.hasFocusedCard && !this.isCardEmpty;
        this.args.onChange?.({
          complete: event.complete,
          empty: event.empty,
          elements: this.paymentElementElements
        });
      });
      _defineProperty(this, "paymentElementFocusHandler", () => {
        this.hasFocusedCard = true;
      });
    }
    get isLabelVisible() {
      return Boolean(this.args.isLabelVisible ?? true);
    }
    get isWalletSelected() {
      return this.stripe.isWalletSelected;
    }
    async setupStripeForm() {
      const {
        elements,
        paymentElement
      } = await this.stripe.createStripePaymentElement({
        elementString: '#e--stripe-payment-element',
        amount: 0,
        planType: this.args.planType
      });
      if (!paymentElement || !elements) {
        return;
      }
      paymentElement.on('change', this.paymentElementChangeHandler);
      paymentElement.once('focus', this.paymentElementFocusHandler);
      this.paymentElement = paymentElement;
      this.paymentElementElements = elements;
    }
    willDestroy() {
      super.willDestroy();
      if (!this.paymentElement) {
        return;
      }
      this.paymentElement.off('change', this.paymentElementChangeHandler);
      this.paymentElement.off('focus', this.paymentElementFocusHandler);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "stripe", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "hasTouchedCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "hasFocusedCard", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isCardEmpty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "setupStripeForm", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setupStripeForm"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, StripePaymentElementComponent);
});